import React from "react";

import {
  RecordCardSkeletonContainer,
  RecordHeaderSkeleton,
  RecordTitleSkeleton,
  RecordSubtitleSkeleton,
  RecordDurationSkeleton,
  RecordStatusSkeleton,
  RecordBottomSkeleton,
} from "./ListRecordedSkeleton.styles";

const RecordCardSkeleton: React.FC = () => (
  <RecordCardSkeletonContainer>
    <RecordHeaderSkeleton>
      <div style={{ flex: 1 }}>
        <RecordTitleSkeleton />
        <div style={{ marginTop: "6px" }}>
          <RecordSubtitleSkeleton />
        </div>
      </div>
      <RecordStatusSkeleton />
    </RecordHeaderSkeleton>
    <RecordBottomSkeleton>
      <RecordDurationSkeleton />
      <div style={{ marginLeft: "8px" }}>
        <RecordDurationSkeleton />
      </div>
    </RecordBottomSkeleton>
  </RecordCardSkeletonContainer>
);

export const ListRecordedSkeleton: React.FC<{ cardCount?: number }> = ({
  cardCount = 5,
}) => {
  return (
    <>
      {Array.from({ length: cardCount }).map((_, index) => (
        <RecordCardSkeleton key={index} />
      ))}
    </>
  );
};
